var chunkMapping = {
	"14": [
		385,
		738,
		5850,
		6725
	],
	"520": [
		9686
	],
	"774": [
		6774
	],
	"861": [
		9541
	]
};
var idToExternalAndNameMapping = {
	"385": [
		"default",
		"./DeviceInspector",
		6625
	],
	"738": [
		"default",
		"./BaseModal",
		6625
	],
	"5850": [
		"default",
		"./OfaForm",
		6625
	],
	"6725": [
		"default",
		"./Sound",
		6625
	],
	"6774": [
		"default",
		"./ViewportRestrict",
		6625
	],
	"9541": [
		"default",
		"./Wheel",
		6625
	],
	"9686": [
		"default",
		"./Milestone",
		6625
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}